export const COMMON_TEXT={
  
    emailAlert: "Please enter valid email",
    passwordAlert: "Please enter password",

}